'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appEntryLoadData = exports.APP_ENTRY_LOAD_DATA_ACTION = undefined;

var _ScreenKeyConst = require('../../../components/screen/ScreenKeyConst');

var _bowser = require('bowser');

var _bowser2 = _interopRequireDefault(_bowser);

var _GuidService = require('../../../services/GuidService');

var _GuidService2 = _interopRequireDefault(_GuidService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APP_ENTRY_LOAD_DATA_ACTION = exports.APP_ENTRY_LOAD_DATA_ACTION = 'APP_ENTRY_LOAD_DATA_ACTION';

/**
 * Loads initial app module data
 * @param {string} moduleId
 * @param {string} elementId
 * @param {any} data 
 */
var appEntryLoadData = exports.appEntryLoadData = function appEntryLoadData(moduleId, elementId, isStandalone, data) {
  var browser = _bowser2.default.getParser(window.navigator.userAgent);
  var _os = browser.getOS();
  var os = _os.name;
  var osVersion = _os.versionName ? _os.versionName : _os.version;
  var client = browser.getBrowserName();
  var clientVersion = browser.getBrowserVersion();
  var platform = browser.getPlatformType(true); // lowercase

  var localeVersion = data.localeVersion || '1.0'; // default locale to v1.0
  var defaultLocale = 'en-US';
  var locale = data.locale || defaultLocale; // default to english
  var defaultLocalePrefix = 'en';
  var localePrefix = locale.toLowerCase().split(/[_-]+/)[0]; // default to english
  var screenId = data.screenId || ''; // default to empty string
  var screenArgs = data.screenArgs || {}; // default to empty object

  // We are using the same english messages for en-US or en-GB.
  // If locale starts with en, then we are not bothering to download english translations.
  // Setting the reactIntlDefaultLocale to the locale here prevents react-intl
  // from spamming console for missing locale messages.
  var reactIntlDefaultLocale = localePrefix === defaultLocalePrefix ? locale : defaultLocale;

  return {
    type: APP_ENTRY_LOAD_DATA_ACTION,
    isStandalone: isStandalone,
    isAuthenticated: !isStandalone,
    moduleId: moduleId,
    elementId: elementId,
    site: data.site,
    companyName: data.companyName,
    memberId: data.memberId,
    memberHash: data.memberHash,
    locale: locale,
    localeVersion: localeVersion,
    defaultLocale: defaultLocale,
    defaultLocalePrefix: defaultLocalePrefix,
    localePrefix: localePrefix,
    reactIntlDefaultLocale: reactIntlDefaultLocale,
    screenId: screenId,
    screenArgs: screenArgs,
    screenKey: _ScreenKeyConst.ACTIVE_SCREEN_KEY,
    os: os,
    osVersion: osVersion,
    client: client,
    clientVersion: clientVersion,
    platform: platform,
    appSessionId: data.appSessionId ? data.appSessionId : (0, _GuidService2.default)(),
    userSessionId: data.userSessionId,
    sessionTag: data.sessionTag
  };
};

exports.default = appEntryLoadData;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/module/actions/AppEntryLoadDataAction.js
// module id = 208
// module chunks = 10